import React from 'react'
import InputRange from 'react-input-range'
import 'react-input-range/lib/css/index.css'
import './RangeSlider.scss'
import noop from 'lib/noop'

const RangeSlider = ({
  max = 0,
  min = 0,
  onChange,
  onChangeComplete,
  step = 1,
  value,
  className = '',
}) => {
  return (
    <div className={className}>
      <InputRange
        formatLabel={noop}
        maxValue={max}
        minValue={min}
        onChange={onChange}
        onChangeComplete={onChangeComplete}
        step={step}
        value={value}
        allowSameValues={false}
      />
    </div>
  )
}

export default React.memo(RangeSlider)
